export default {
    buttons: Boolean, 
    clearButton: Boolean, 
    columns: Number, 
    tileSize: Number | Object, 
    messages: Object, 
    palette: String | Array, 
    opacity: Boolean, 
    preview: Boolean, 
    toolIcon: String, 
    value: String, 

    // Events
    change: Function, 
    select: Function, 
    open: Function, 
    close: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPicker/ColorPickerProps.js